export const environment = {
  testing: false,
  production: false,
  staging: true,
  urls: {
    service: "https://service.latest.tripmakery.com",
    blob: "https://tripmakerystaging.blob.core.windows.net/housings/img",
    blobDestinations: "https://tripmakerystaging.blob.core.windows.net/destinations",
    kitchen: "https://admin.latest.tripmakery.com",
    partner: "https://partner.latest.tripmakery.com",
    pro: "https://pro.latest.tripmakery.com",
    tool: "https://admin-tool.latest.tripmakery.com",
    user: "https://user.latest.tripmakery.com",
    landingpage: "https://latest.tripmakery.com"
  },
  xauth: 'RmtIp7aeVbHxNjxaQgpN1MDAjkbIHiSKUlkV23SlLHAtKcpbPv24YuXwEgftFsBY',
};
